import { useCallback } from "react"
import AxiosService from "../lib/axios";
import { AUTH_FRONTEND_USER_TYPE } from "../services/auth.service";

export const useProfile = () => {

    const getTypeRole = useCallback(() => {
        return AxiosService.getRole() || AUTH_FRONTEND_USER_TYPE;
    }, [])

    const getProfileId = useCallback(() => {
        return AxiosService.getIdToken();
    }, [])

    const getTypeRoleUser = useCallback(() => {
        return AxiosService.getTypeRole() || AUTH_FRONTEND_USER_TYPE;
    }, [])

    return {
        getTypeRole,
        getProfileId,
        getTypeRoleUser
    }
}
